module.exports = __webpack_public_path__ + "static/media/pra-vendas-logo.1496fad7.png";